import React, { Component } from 'react';
import { connect } from 'react-redux';
import { recordsActions } from '../actions/records.actions';
import { recordsConstants } from '../constants/records.constants';
import { Button, Slider, List, Row, Col, Alert, Spin, Icon, Tooltip, Select } from 'antd';
import moment from 'moment';
import PhoneNumber from '../components/PhoneNumber/PhoneNumber';
import { SipPhoneContext } from '../components/SipPhoneProvider';
import { SIP_STATUS_CONNECTED, SIP_STATUS_REGISTERED } from '../components/SipPhoneProvider/constants/statuses';
import BindCallToRequest from '../components/BindCallToRequest/BindCallToRequest';
import BindCallToRequestFromList from './Requests/components/BindCallToRequestFromList';
import DeleteCallLisRecord from './Requests/components/DeleteCallLisRecord/DeleteCallLisRecord';

class RecordsPanelContainer extends Component {
	static contextType = SipPhoneContext;
	
	constructor(props) {
		super(props)

		this.handleBindCallSuccess = this.handleBindCallSuccess.bind(this);

		this.state = {
			records: [],
			dataFetching: false
		}
	}
	
	componentDidMount() {
		this.setState({dataFetching: true})
		recordsActions.fetchRecords(this.props.request)
			.then(
				data => { 
					console.log("=== records ===")
					console.log(data.data)
					this.setState({records: data.data, dataFetching: false}) },
				err => { this.setState({dataFetching: false}); console.log(err) })	
	}

	componentDidUpdate(pp) {
		if(pp.request !== this.props.request) {
			this.setState({dataFetching: true})
			recordsActions.fetchRecords(this.props.request)
			.then(
				data => { this.setState({records: data.data, dataFetching: false}) },
				err => { this.setState({dataFetching: false}); console.log(err) })	
		}

	}

	handleBindCallSuccess() {
		this.setState({dataFetching: true})
			recordsActions.fetchRecords(this.props.request)
			.then(
				data => { this.setState({records: data.data, dataFetching: false}) },
				err => { this.setState({dataFetching: false}) })	
	}

	render() {
		const { 
			playing, 
			recordId, 
			recordIdDownload, 
			recordPosition, 
			duration, 
			dataFetching, 
			dataFetchingDownload,
			apiResponseError,
			request,
			playbackRate,
		} = this.props;

		const { sip, call } = this.context;

		const isConnected = sip.status === SIP_STATUS_REGISTERED;
		const canBindCall = isConnected && call.info?.id;

/*		.dspx-records-list .ant-list-item-content {
			margin-bottom: -14px !important;
			font-size: 12px !important
	} */
	
	const recordsItemStyle =  {
			//padding-top: 0px !important; 
			paddingBottom: 2,
			marginBottom: 10,
			minWidth: '450px',
			//max-width: 255px;
			borderBottom: "none",
	} 

	const recordSliderStyle = {
    padding: 0,
		margin: '0px 0px 0px 0px',
		position: 'relative',
		top: '-12px',
    height: '0px',
	}

	function mdiv(val){
    return (val - val % 60) / 60;
	}

	function posFormatter(value) {	
		console.log("=== posFormatter ===")	
		console.log(value)	
		return mdiv(value).toString()+':'+(value % 60).toString().padStart(2,'0')
	}
	
	//console.log(this.state.records)

		return (
			<Spin size="large" spinning={this.state.dataFetching} tip="Загрузка..." delay={100}>

			<div className='dspx-records'>
			{ /*apiResponseError &&<Alert message={this.props.apiResponseText} type="error" showIcon /> */}
			{canBindCall && (
				<BindCallToRequest
					requestId={request}
					onSuccess={this.handleBindCallSuccess}
					render={({ onClick }) => (
						<Button
							ghost
							block
							type="primary"
							style={{ marginBottom: '12px' }}
							onClick={onClick}
						>
							Прикрепить текущий звонок
						</Button>
					)}
				/>
			)}
			<BindCallToRequestFromList requestId={request}  				onSuccess={this.handleBindCallSuccess}/>
			<List 
				itemLayout="vertical"
				size="small"
				pagination={{
					hideOnSinglePage: true,
					pageSize: 5,
					size: 'small',
				}}
				dataSource={this.state.records}
				renderItem={item => {

					const dt = item.createTime;

					const isCurrent = recordId === item.id;
					const isCurrentDownload = recordIdDownload === item.id;
					const butIcon = !isCurrent ? 'play-circle' : dataFetching ? 'loading' : playing  ? 'pause-circle' : 'play-circle'
					const downloadIcon = !isCurrentDownload ? 'download' : dataFetchingDownload ? 'loading' : 'download'
					const resume = isCurrent;
					const handleDownloadClick = () => {this.props.dispatch(recordsActions.fechAndSave(item)) }
					const handleOnClick = 
						dataFetching ? 
							() => {} : 
							butIcon === 'pause-circle' ?
								() => { this.props.dispatch(recordsActions.pause()) } :
								(resume ?
									() => { this.props.dispatch(recordsActions.resume()) } :
									() => { this.props.dispatch(recordsActions.fechAndPlay(item.id)) });

					return (
						<List.Item key={item.id} style={recordsItemStyle} >
							<Row gutter={0} style={{whiteSpace: 'nowrap' }}>
								<Col span={7} style={{whiteSpace: 'nowrap', fontSize: '13px'}}>
									<span>{moment(dt).format('DD.MM.YY')}</span>
									<span style={{marginLeft: 6 }}>{moment(dt).format('HH:mm:ss')}</span>
								</Col>
								<Col span={1} style={{textAlign: 'right', fontSize: '16px'}}>
									<Tooltip title={item.direction == 'out' ? "исходящий" : "входящий"}>
										<Icon type={item.direction == 'out' ? "caret-right" : "caret-left"} 
									 		style={{ 
												 color: item.direction == 'out' ? "green" : "red",
												 position: 'relative',
												 top: -1,
											}} theme="filled" />
										</Tooltip>
								</Col>
								<Col span={5} style={{textAlign: 'right', fontSize: '13px', fontWeight: "600"}}>
									{item.phoneNumber && <PhoneNumber phoneNumber={item.phoneNumber} />}
								</Col>
								<Col span={4} style={{color: "#005f8e", textAlign: 'right', fontSize: '12px', fontWeight: "400", paddingRight: 6}}>
										{posFormatter(item.duration)}
								</Col>
								<Col span={2} style={{textAlign: 'center'}} >
									<Button shape="circle" icon={butIcon} onClick={handleOnClick}
										style={{top:'-11px',  color: '#b7b7b7', border: 'none', fontSize: 25 }} />	
								</Col>
								<Col span={3} style={{textAlign: 'center'}}>
									<Button shape="circle" icon={downloadIcon} onClick={handleDownloadClick}
										style={{top:'-11px',  color: '#b7b7b7', border: 'none', fontSize: 25}} />	
								</Col>
								<DeleteCallLisRecord recordId={item.id} requestId={request} />
							</Row>
							{isCurrent && !apiResponseError &&
							<>
							<Row style= {{height: '0px'}}>
								<Col span={19} >
									<Slider style={recordSliderStyle} max={Math.round(duration)} value={recordPosition} 
									  tipFormatter={posFormatter}
										onAfterChange={(val)=>{ this.props.dispatch(recordsActions.moveTo(val)) }}	
										onChange={(val)=>{ this.props.dispatch( recordsActions.updateTimer(val)) }}	
									/>
								</Col>
								<Col span={5} >
								</Col>
							</Row>
							<Row>
								<Col span={16}>Скорость воспроизведения:</Col>
								<Col span={8}>
									  <Select
											value={playbackRate}
											onChange={(rate) => this.props.dispatch(recordsActions.setPlaybackRate(rate))}
											style={{ width: '100%' }}
										>
											<Select.Option value={0.75}>0.75x</Select.Option>
											<Select.Option value={1}>1x</Select.Option>
											<Select.Option value={1.25}>1.25x</Select.Option>
											<Select.Option value={1.5}>1.5x</Select.Option>
										</Select>
								</Col>
							</Row>
							</>}
						</List.Item>
					)
				}}
			/>
			</div> 
			</Spin>
		)
	}
}

function mapStateToProps(state) {

	const { recordsStore } = state;

	return recordsStore;
}

export default connect(mapStateToProps)(RecordsPanelContainer);